<template>
  <ModalVue :fields="[
                  {
                    name: 'name',
                    type: 'text',
                    tag: 'input',
                    placeholder: 'nazwa',
                    req: true,
                    value: user.name
                  },
                  {
                    name: 'phone',
                    type: 'tel',
                    tag: 'input',
                    placeholder: 'numer telefonu',
                    req: true,
                    htmlPattern: '[0-9]{9}',
                    value: user.phone,
                    label: 'numer telefonu'
                  },
                  {
                    name: 'state_id',
                    tag: 'select',
                    options: states,
                    value: user.state_id,
                    label: 'województwo'
                  },
                  {
                    name: 'address',
                    type: 'text',
                    tag: 'input',
                    placeholder: 'adres',
                    req: false,
                    value: user.address,
                    label: 'adres'
                  },
                  {
                    name: 'category_id',
                    tag: 'select',
                    options: categories,
                    value: user.category_id,
                    label: 'kategoria'
                  },
                ]" title="edytuj dane" button-text="zatwierdź" :isVisible="isModalVisible" @closeModal="() => {isModalVisible=false}" @sendData="(data) => editUser(data)"/>
  <ModalVue :fields="[
      {
        name: 'oldpassword',
        type: 'password',
        tag: 'input',
        req: true,
        placeholder: 'obecne hasło'
      },
      {
        name: 'newpassword',
        type: 'password',
        tag: 'input',
        req: true,
        placeholder: 'nowe hasło',
        minlength: 8
      },
      {
        name: 'repeatnewpassword',
        type: 'password',
        tag: 'input',
        req: true,
        placeholder: 'powtórz nowe hasło',
        minlength: 8
      }
    ]" title="zmnień hasło" :is-visible="isPassModalVisible" button-text="zmień" @closeModal="() => {isPassModalVisible=false}" @sendData="(data) => changePass(data)"/>
  <ModalVue :fields="[
      {
        name:'photo',
        type:'file',
        tag: 'input',
        req: true
      }
    ]" title="prześlij zdjęcie" button-text="wyślij" :is-visible="isPhotoModalVisible" @closeModal="() => {isPhotoModalVisible=false}" @sendData="(data) => sendPhoto(data)"/>

  <div v-if="currentUser && currentUser.role_id === 5" class="user-data-page">
    <div class="page-header">
      <h1>Twoje dane</h1>
      <div class="header-actions">
        <button class="btn-outline" @click="isModalVisible = true">Edytuj profil</button>
        <button class="btn-primary" @click="isPassModalVisible = true">Zmień hasło</button>
      </div>
    </div>

    <div class="layout">
      <section class="section-card profile-card">
        <div class="profile-top-actions">
          <button class="btn-icon" @click="isModalVisible = true" title="Edytuj">
            <img src="@/assets/icons/pencil-square.svg" alt="edytuj">
          </button>
        </div>

        <button
            class="avatar-btn"
            @click="() => {
                if (!userPhotoUrl) {
                  isPhotoModalVisible = true
                } else {
                  removePhoto()
                }
              }"
            :title="userPhotoUrl ? 'Usuń zdjęcie' : 'Dodaj zdjęcie'"
        >
          <img class="avatar" :src="userPhotoUrl ? userPhotoUrl : getImageUrl()" alt="">
          <span class="avatar-overlay">
              <img v-if="!userPhotoUrl" src="@/assets/icons/pencil-square.svg" alt="dodaj">
              <img v-else src="@/assets/icons/trash.svg" alt="usuń">
            </span>
        </button>

        <h2 class="profile-name">{{ user.name }}</h2>
        <p class="profile-email">{{ user.email }}</p>

        <div class="info-list">
          <p :class="{ muted: !user.address }">{{ user.address || 'brak adresu' }}</p>
          <p :class="{ muted: !user.phone }">tel: {{ user.phone || 'brak numeru telefonu' }}</p>
          <p :class="{ muted: !user.category_id }">
            {{
              user.category_id
                  ? `${categories.find(e => user.category_id == e.id) ? categories.find(e => user.category_id == e.id).name : 'brak kategorii'}`
                  : 'brak kategorii'
            }}
          </p>
          <p :class="{ muted: !user.state_id }">
            {{
              user.state_id
                  ? `${states.find(e => user.state_id == e.id) ? states.find(e => user.state_id == e.id).name : 'brak województwa'}`
                  : 'brak województwa'
            }}
          </p>
        </div>

        <div class="card-actions">
          <button class="btn-primary" @click="isPassModalVisible = true">Zmień hasło</button>
          <button class="btn-outline" @click="$router.push(`/browse/user/${currentUser.id}`)">Twoja wizytówka</button>
          <button class="btn-danger" @click="confirmDelete = true">Usuń konto</button>
        </div>

        <div class="confirm-delete" v-if="confirmDelete">
          <span>Czy na pewno?</span>
          <div>
            <button class="btn-danger" @click="deleteAccount">Tak</button>
            <button class="btn-outline" @click="confirmDelete = false">Nie</button>
          </div>
        </div>
      </section>

      <section class="section-card forms-card">
        <form class="account-change-form" @submit.prevent="changeAccountType" @reset.prevent="accountChangeConfirm = false">
          <h3>Zmiana typu konta</h3>
          <b>Jesteś specjalistą i świadczysz usługi?</b>
          <p>
            Jeśli jesteś specjalistą i świadczysz usługi, zmień typ konta, żeby mieć taką możliwość.
            Aktualne konto skierowane jest do klinik/placówek, które zatrudniają specjalistów.
            Konto specjalisty jest płatne według <RouterLink to="/dla-biznesu">cennika</RouterLink>.
          </p>

          <button type="button" class="btn-primary" v-if="!accountChangeConfirm" @click="accountChangeConfirm = true">
            Jestem specjalistą
          </button>

          <div class="account-confirm" v-if="accountChangeConfirm">
            <span>Jesteś pewny/a?</span>
            <div>
              <button type="submit" class="btn-primary">Tak</button>
              <button type="reset" class="btn-outline">Nie</button>
            </div>
          </div>
        </form>

        <form @submit.prevent="editUser()">
          <h3>Opisy działalności</h3>

          <label for="shortDescription">Krótki opis działalności</label>
          <textarea name="shortDescription" id="shortDescription" v-model="user.short_description" required maxlength="350" minlength="20"></textarea>

          <label for="description">Opis działalności</label>
          <textarea name="description" id="description" v-model="user.description" required maxlength="3000" minlength="80"></textarea>

          <button type="submit" class="btn-primary">Zapisz opisy</button>
        </form>
      </section>
    </div>
  </div>

  <div v-else class="fallback">
    <h2>Błąd wczytywania. Spróbuj ponownie.</h2>
  </div>
</template>
  
  <script>
  import ModalVue from '@/components/Modal.vue'
  import authHeader from '@/services/auth-header';
  import axios from 'axios';
  import { useMeta } from 'vue-meta'
  import {useAuthStore} from "@/stores/auth";
  import {useAppStore} from "@/stores/app";
  
  export default{
      name: 'FirmUserData',
      data() {
          return {
              userPhotoUrl: '',
              userPhotoId: '',
              isModalVisible: false,
              isPhotoModalVisible: false,
              states:[],
              categories: [],
              accountChangeConfirm: false,
              isPassModalVisible: false,
              confirmDelete: false,
              user:{
                address: '',
                description: '',
                short_description: '',
                phone: '',
                name: '',
                category_id: null,
                state_id: null,
                email: '',
                nip: '',
                krs: '',
                regon: '',
                fv: []
              }
          };
      },
      setup() {
          useMeta({ title: 'twoje dane' });
      
    return {
        authStore: useAuthStore(),
        appStore: useAppStore(),
    }
  },
      props: {},
      computed: {
          currentUser() {
              return this.authStore.user;
          }
      },
      mounted() {
          if (!this.currentUser) {
              this.$router.push('/login');
          }
          else if (this.currentUser.role_id !== 5) {
              this.$router.push('/login');
          }
          this.getUserData()
      },
      methods: {
          getImageUrl() {
              return new URL(`../../assets/photo-placeholder.png`, import.meta.url).href;
          },
          getUserData(){
            axios.get(`/User/${this.currentUser.id}`).then(res => {
              this.user = res.data
            })
  
            axios.get(`/UserImage/${this.currentUser.id}`).then(res => {
              if(res.data.length > 0){
                this.userPhotoUrl = res.data[0].photo_url
                this.userPhotoId = res.data[0].id
              }
            })

            axios.get('/State').then(res => {
              res.data.forEach(e => {
                e.value = e.id
              })
              this.states = res.data
            })

            axios.get('/Categories').then(res => {
              res.data.forEach(e => {
                e.value = e.id
              })
              this.categories = res.data
            })
          },
          editUser(data){
            this.user.fv = []
            Object.assign(this.user, data)
            this.user.id = this.currentUser.id
            axios.post(`/UserProfile`, this.user, authHeader()).then(() => {
              this.appStore.setIsSuccess('Pomyślnie zaktualizowano dane')
            })
          },
          sendPhoto(data){
            axios.post('/UserImage', {
              user_id: this.currentUser.id,
              photo: data.photo
            },{ 
                headers:{
                          ['Content-Type']: 'multipart/form-data'
                }
              }
            ).then(res => {
              if(String(res.status).charAt(0) == '2'){
                this.appStore.setIsSuccess('Pomyślnie dodano zdjęcie')
                this.userPhotoUrl = URL.createObjectURL(data.photo)
              }
            })
          },
          removePhoto(){
            axios.delete(`/UserImage/${this.userPhotoId}`, authHeader).then((res) => {
              if(String(res.status).charAt(0) == '2'){
                this.appStore.setIsSuccess('Pomyślnie usunięto zdjęcie')
                this.userPhotoUrl = ''
              }
            }).catch(() => {
              
              setTimeout(() => {
                location.reload()
              }, 500)
            })
          },
          changeAccountType(){
            axios.get(`/UserChangeRoleId/2`, authHeader()).then(() => {
              this.authStore.logout();
              this.$router.push('/login')
            })
          },
          changePass(data){
            axios.post('/ChangePassword', {
              oldpassword: data.oldpassword,
              newpassword: data.newpassword,
              repeatpassword: data.repeatnewpassword
            }, authHeader()).then(res => {
              if(String(res.status).charAt(0) === '2'){
                this.appStore.setIsSuccess('Pomyślnie zaktualizowano hasło')
                window.location.href = '/';
              }
            })
        },
        deleteAccount(){
            axios.delete(`/User/${this.currentUser.id}`, authHeader()).then(() => {
              this.$router.push('/')
              localStorage.removeItem('userm2VET');
              window.location.reload()
            })
          }
      },
      components: { ModalVue },
  }
  </script>

<style scoped lang='scss'>
.user-data-page {
  background: #ffffff;
  min-height: 100vh;
  padding: 24px 16px 32px;
  color: #1f2937;
}

.page-header {
  max-width: 1200px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  border-bottom: 2px solid #e5e7eb;
  padding-bottom: 14px;
}

.page-header h1 {
  margin: 0;
  font-size: 2.8rem;
  font-weight: 700;
}

.header-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.layout {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 20px;
  align-items: flex-start;
  flex-wrap: wrap;
}

.section-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  padding: 16px;
  box-sizing: border-box;
}

.profile-card {
  width: 320px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.profile-top-actions {
  display: flex;
  justify-content: flex-end;
}

.avatar-btn {
  border: none;
  background: none;
  cursor: pointer;
  align-self: center;
  width: 120px;
  height: 120px;
  position: relative;
  border-radius: 999px;
  overflow: hidden;
  padding: 0;
}

.avatar {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 999px;
  border: 2px solid #e5e7eb;
  box-sizing: border-box;
}

.avatar-overlay {
  position: absolute;
  inset: 0;
  background: rgba(17, 24, 39, 0.35);
  opacity: 0;
  transition: 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-overlay img {
  width: 20px;
  height: 20px;
}

.avatar-btn:hover .avatar-overlay {
  opacity: 1;
}

.profile-name {
  margin: 6px 0 0;
  text-align: center;
  font-size: 1.9rem;
}

.profile-email {
  margin: 0;
  text-align: center;
  color: #6b7280;
}

.info-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-list p {
  margin: 0;
  font-size: 1.4rem;
  color: #374151;
  text-align: center;
}

.info-list p.muted {
  color: #9ca3af;
}

.card-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}

.confirm-delete {
  margin-top: 8px;
  background: #fff1f2;
  border: 1px solid #fecdd3;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
}

.confirm-delete div {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
}

.forms-card {
  flex: 1 1 0;
  min-width: 0;
}

.forms-card form {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 14px;
  margin-bottom: 14px;
  border-bottom: 1px solid #e5e7eb;
}

.forms-card form:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.forms-card h3 {
  margin: 0 0 4px;
  font-size: 1.7rem;
}

.forms-card label,
.forms-card p {
  font-size: 1.35rem;
  color: #374151;
}

.forms-card p {
  margin: 0;
  line-height: 1.5;
}

.forms-card a {
  color: #2563eb;
  text-decoration: none;
}

.forms-card a:hover {
  text-decoration: underline;
}

.forms-card textarea {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 1.4rem;
  box-sizing: border-box;
  outline: none;
  transition: 0.2s;
  min-height: 100px;
  resize: vertical;
}

.forms-card textarea:focus {
  border-color: #10b981;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.12);
}

.account-confirm {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
}

.account-confirm div {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.btn-primary,
.btn-outline,
.btn-danger,
.btn-icon {
  border-radius: 8px;
  font-size: 1.35rem;
  cursor: pointer;
}

.btn-primary {
  background: #f97316;
  color: #ffffff;
  border: none;
  padding: 10px 14px;
  font-weight: 600;
}

.btn-primary:hover {
  background: #ea6c0a;
}

.btn-outline {
  background: #ffffff;
  color: #1f2937;
  border: 1px solid #d1d5db;
  padding: 10px 14px;
}

.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

.btn-danger {
  background: #dc3545;
  color: #ffffff;
  border: none;
  padding: 10px 14px;
}

.btn-danger:hover {
  background: #b91c1c;
}

.btn-icon {
  background: none;
  border: none;
  padding: 6px;
}

.btn-icon img {
  width: 18px;
  height: 18px;
}

.fallback {
  padding: 24px;
  text-align: center;
}

@media (max-width: 980px) {
  .layout {
    flex-direction: column;
  }

  .profile-card {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .user-data-page {
    padding: 16px 12px 24px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .btn-primary,
  .btn-outline,
  .btn-danger {
    width: 100%;
    text-align: center;
  }

  .confirm-delete div,
  .account-confirm div {
    width: 100%;
  }

  .confirm-delete div button,
  .account-confirm div button {
    flex: 1;
  }
}
</style>